/**
 * @file 生成请求序列号，用于统计丢失率
 * @author wuyufeng<wuyufeng@baijiahulian.com>
 * @module util/requestIdx
 */
import { Config } from './config';
import detectLocalStorage from './detectLocalStorage';
/**
 * 将日期转成 YYYY-MM-DD 的格式
 * @param {Date} recordDay
 */

export var getDate = function getDate(recordDay) {
  return "".concat(recordDay.getFullYear(), "-").concat(recordDay.getMonth() + 1, "-").concat(recordDay.getDate());
};

var isObject = function isObject(target) {
  return Object.prototype.toString.call(target).slice(8, -1) === 'Object';
}; // 存储 req_idx 键。


var KEY = 'REQ_IDX';
var isClient = typeof window !== 'undefined'; // 能否使用 localStorage 标识符。

var CAN_I_USE_STORE = detectLocalStorage(isClient);
export var defaultReqIdxStore = function defaultReqIdxStore() {
  return {
    recordDay: '',
    data: {}
  };
};
var ReqIdxStore = null;
/**
 * 从 localStorage 中获取 ReqIdxStore 。
 */

var getReqIdxFromStore = function getReqIdxFromStore() {
  try {
    var _JSON$parse = JSON.parse(localStorage.getItem("".concat(Config.NAME, "-").concat(KEY))),
        _JSON$parse$recordDay = _JSON$parse.recordDay,
        recordDay = _JSON$parse$recordDay === void 0 ? '' : _JSON$parse$recordDay,
        _JSON$parse$data = _JSON$parse.data,
        data = _JSON$parse$data === void 0 ? {} : _JSON$parse$data;

    return {
      recordDay: recordDay,
      data: isObject(data) ? data : {}
    };
  } catch (e) {
    return ReqIdxStore || defaultReqIdxStore();
  }
};
/**
 * 初始化 ReqIdxStore 。
 * @param {any} store
 */


export var initReqIdxStore = function initReqIdxStore(store) {
  ReqIdxStore = typeof store === 'undefined' ? CAN_I_USE_STORE ? getReqIdxFromStore() : defaultReqIdxStore() : store;
};
/**
 * 将 ReqIdxStore 保存至 localStorage 。
 */

var saveReqIdxToStore = function saveReqIdxToStore() {
  var _ = function _() {
    localStorage.setItem("".concat(Config.NAME, "-").concat(KEY), JSON.stringify(ReqIdxStore));
  };

  CAN_I_USE_STORE && _();
};
/**
 * 计算 req_idx ，用于统计丢失率，以四个维度区分，recordDay && Config.Name && type 。
 */


var getReqIdx = function getReqIdx(url, gid) {
  var type = Object.keys(Config).filter(function (key) {
    return Config[key] === url;
  })[0]; // 获取当前日期，对比 store 中日期，不同则重置。

  var today = getDate(new Date());

  if (!ReqIdxStore) {
    initReqIdxStore();
  }

  CAN_I_USE_STORE && (ReqIdxStore = getReqIdxFromStore());
  var _ReqIdxStore = ReqIdxStore,
      recordDay = _ReqIdxStore.recordDay,
      data = _ReqIdxStore.data;
  today !== recordDay && (data = {}) && (recordDay = today);
  var key = "".concat(Config.NAME, "-").concat(type, "-").concat(gid || 'nogid');
  key in data ? data[key]++ : data[key] = 1;
  ReqIdxStore.recordDay = recordDay;
  ReqIdxStore.data = data;
  saveReqIdxToStore();
  return data[key];
};

export default getReqIdx;